module.exports = __webpack_public_path__ + "fonts/8cfe82e.woff2";